
import React from 'react';
import { Card } from '../ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const data = [
  { name: 'Accept All', value: 65 },
  { name: 'Necessary Only', value: 25 },
  { name: 'Reject All', value: 10 },
];

const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];

const pageViewsData = [
  { page: 'Home', views: 1200 },
  { page: 'Jobs', views: 800 },
  { page: 'About', views: 400 },
  { page: 'Login', views: 320 },
  { page: 'Signup', views: 280 },
];

const CookieAnalytics = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Cookie Consent Analytics</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Consent Distribution</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </Card>
        
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Page Views (with cookies)</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={pageViewsData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="page" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="views" fill="#4f46e5" />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>
      
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Cookie Policy Summary</h3>
        <div className="space-y-4">
          <div>
            <h4 className="font-medium">Cookie Acceptance Rate</h4>
            <p className="text-3xl font-bold text-green-600">65%</p>
            <p className="text-sm text-gray-500">Users accepting all cookies</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="border rounded-lg p-4">
              <p className="text-sm text-gray-500">Most Popular Page with Cookies</p>
              <p className="font-semibold">Home Page</p>
              <p className="text-sm text-gray-500">1200 views</p>
            </div>
            
            <div className="border rounded-lg p-4">
              <p className="text-sm text-gray-500">Avg Time Before Consent</p>
              <p className="font-semibold">35 seconds</p>
              <p className="text-sm text-gray-500">From page load to decision</p>
            </div>
            
            <div className="border rounded-lg p-4">
              <p className="text-sm text-gray-500">Banner Dismissal Rate</p>
              <p className="font-semibold">12%</p>
              <p className="text-sm text-gray-500">Users dismissing without consent</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CookieAnalytics;
